/* eslint-disable react-hooks/exhaustive-deps */
// src/components/Reporte2.js

import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Button,
  Container,
  Grid,
  Header,
  Icon,
  Input,
  Label,
  Message,
  Segment,
  Table,
} from "semantic-ui-react";

import {
  collection,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";

import moment from "moment";

import { db } from "../firebase/firebaseConfig";
import { UserContext } from "../context/UserContext";
import ExportarExcel from "../funciones/ExportarExcel";

/* =====================================================
   ESTILOS
===================================================== */

const stickyTh = {
  position: "sticky",
  top: 0,
  zIndex: 2,
  background: "#f8fafc",
  color: "#42526e",
  fontSize: 11,
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: 0.25,
  whiteSpace: "nowrap",
  borderBottom: "1px solid #dfe3e8",
};

/* =====================================================
   HELPERS STATUS
===================================================== */

const normalizarTexto = (valor) => {
  return String(valor || "")
    .trim()
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

const getStatusConfig = (status) => {
  const value = normalizarTexto(status);

  const configs = {
    PREPARACION: {
      label: "PREPARACIÓN",
      color: "#fbbd08",
      background: "#fff8db",
      border: "#f4d35e",
      icon: "hourglass half",
    },

    BODEGA: {
      label: "BODEGA",
      color: "#2185d0",
      background: "#eaf4fb",
      border: "#b8d8ef",
      icon: "archive",
    },

    "TRANSITO PACIENTE": {
      label: "TRÁNSITO PACIENTE",
      color: "#159447",
      background: "#eafaf0",
      border: "#bde8c9",
      icon: "truck",
    },

    "TRANSITO ST": {
      label: "TRÁNSITO ST",
      color: "#f2711c",
      background: "#fff1e8",
      border: "#f5c6a5",
      icon: "truck",
    },

    "SERVICIO TECNICO": {
      label: "SERVICIO TÉCNICO",
      color: "#6435c9",
      background: "#f0ebfb",
      border: "#cfc0ee",
      icon: "wrench",
    },

    PACIENTE: {
      label: "PACIENTE",
      color: "#478155",
      background: "#edf5ef",
      border: "#bfd6c5",
      icon: "user",
    },

    "TRANSITO BODEGA": {
      label: "TRÁNSITO BODEGA",
      color: "#00a9a5",
      background: "#e6f8f7",
      border: "#afe1df",
      icon: "truck",
    },

    BAJA: {
      label: "BAJA",
      color: "#767676",
      background: "#f1f1f1",
      border: "#d5d5d5",
      icon: "ban",
    },

    "TRANSITO PROVEEDOR": {
      label: "TRÁNSITO PROVEEDOR",
      color: "#db2828",
      background: "#fceaea",
      border: "#efb7b7",
      icon: "truck",
    },

    PROVEEDOR: {
      label: "PROVEEDOR",
      color: "#a333c8",
      background: "#f5eafb",
      border: "#dabce9",
      icon: "building",
    },
  };

  return (
    configs[value] || {
      label: status || "SIN STATUS",
      color: "#6b778c",
      background: "#f4f5f7",
      border: "#dfe1e6",
      icon: "question circle outline",
    }
  );
};

const StatusBadge = ({ status }) => {
  const config = getStatusConfig(status);

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: "4px 8px",
        borderRadius: 5,
        fontSize: 10,
        fontWeight: 700,
        whiteSpace: "nowrap",
        color: config.color,
        background: config.background,
        border: `1px solid ${config.border}`,
      }}
    >
      <Icon
        name={config.icon}
        style={{
          margin: 0,
          fontSize: 10,
        }}
      />

      {config.label}
    </span>
  );
};

/* =====================================================
   COMPONENTE
===================================================== */

const Reporte2 = () => {
  const { users } = useContext(UserContext);

  const [estado, setEstado] = useState([]);
  const [buscador, setBuscador] = useState("");

  const [loading, setLoading] = useState(true);
  const [errorCarga, setErrorCarga] = useState("");

  /* =====================================================
     HELPERS
  ===================================================== */

  const formatearFecha = (fecha) => {
    if (!fecha) {
      return "";
    }

    if (fecha?.toDate) {
      return moment(fecha.toDate()).format(
        "DD/MM/YYYY HH:mm:ss"
      );
    }

    const fechaMoment = moment(fecha);

    return fechaMoment.isValid()
      ? fechaMoment.format("DD/MM/YYYY HH:mm:ss")
      : "";
  };

  const toSearchText = (value) => {
    if (
      value === null ||
      value === undefined
    ) {
      return "";
    }

    if (value?.toDate) {
      return moment(value.toDate()).format(
        "DD/MM/YYYY HH:mm:ss"
      );
    }

    if (Array.isArray(value)) {
      return value
        .map(toSearchText)
        .join(" ");
    }

    if (typeof value === "object") {
      try {
        return JSON.stringify(value);
      } catch {
        return String(value);
      }
    }

    return String(value);
  };

  const onBuscarCambios = (e) => {
    setBuscador(e.target.value);
  };

  const limpiarBusqueda = () => {
    setBuscador("");
  };

  /* =====================================================
     STATUS EN TIEMPO REAL
  ===================================================== */

  useEffect(() => {
    if (!users?.emp_id) {
      setEstado([]);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    setErrorCarga("");

    const traerStatus =
      collection(db, "status");

    const q = query(
      traerStatus,
      where(
        "emp_id",
        "==",
        users.emp_id
      )
    );

    const unsubscribe =
      onSnapshot(
        q,
        (snap) => {
          const data =
            snap.docs.map(
              (documento) => ({
                id: documento.id,
                ...documento.data(),
              })
            );

          setEstado(data);
          setLoading(false);
          setErrorCarga("");
        },
        (error) => {
          console.error(
            "Error escuchando status en línea:",
            error
          );

          setEstado([]);
          setLoading(false);

          setErrorCarga(
            "No fue posible cargar el estado de los equipos."
          );
        }
      );

    return () => {
      unsubscribe();
    };
  }, [users?.emp_id]);

  /* =====================================================
     ORDEN + FILTRO
  ===================================================== */

  const datosFiltrados =
    useMemo(() => {
      const textoBusqueda =
        String(
          buscador || ""
        )
          .trim()
          .toLowerCase();

      const ordenados =
        [...estado].sort(
          (a, b) => {
            const statusA =
              normalizarTexto(
                a.status
              );

            const statusB =
              normalizarTexto(
                b.status
              );

            const comparacionStatus =
              statusA.localeCompare(
                statusB,
                "es",
                {
                  sensitivity:
                    "base",
                }
              );

            if (
              comparacionStatus !==
              0
            ) {
              return comparacionStatus;
            }

            const destinoA =
              String(
                a.n_destino || ""
              );

            const destinoB =
              String(
                b.n_destino || ""
              );

            const comparacionDestino =
              destinoA.localeCompare(
                destinoB,
                "es",
                {
                  sensitivity:
                    "base",
                }
              );

            if (
              comparacionDestino !==
              0
            ) {
              return comparacionDestino;
            }

            return String(
              a.serie || ""
            ).localeCompare(
              String(
                b.serie || ""
              ),
              "es",
              {
                sensitivity: "base",
              }
            );
          }
        );

      if (!textoBusqueda) {
        return ordenados;
      }

      return ordenados.filter(
        (item) =>
          Object.keys(
            item
          ).some((key) =>
            toSearchText(
              item[key]
            )
              .toLowerCase()
              .includes(
                textoBusqueda
              )
          )
      );
    }, [estado, buscador]);

  /* =====================================================
     KPIs
  ===================================================== */

  const indicadores =
    useMemo(() => {
      const contar = (
        estadoBuscado
      ) =>
        estado.filter(
          (item) =>
            normalizarTexto(
              item.status
            ) ===
            estadoBuscado
        ).length;

      const enTransito =
        estado.filter(
          (item) =>
            normalizarTexto(
              item.status
            ).includes(
              "TRANSITO"
            )
        ).length;

      const servicioTecnico =
        estado.filter(
          (item) =>
            normalizarTexto(
              item.status
            ) ===
              "SERVICIO TECNICO" ||
            normalizarTexto(
              item.status
            ) ===
              "TRANSITO ST"
        ).length;

      return {
        total: estado.length,

        bodega:
          contar("BODEGA"),

        paciente:
          contar("PACIENTE"),

        transito:
          enTransito,

        servicioTecnico,
      };
    }, [estado]);

  /* =====================================================
     TIPO MOVIMIENTO
  ===================================================== */

  const getTipoMovimientoStyle = (
    tipo
  ) => {
    const value =
      normalizarTexto(tipo);

    if (
      value.includes(
        "ENTRADA"
      )
    ) {
      return {
        color: "#2185d0",
        background:
          "#eaf4fb",
        border: "#b8d8ef",
      };
    }

    if (
      value.includes(
        "SALIDA"
      )
    ) {
      return {
        color: "#6435c9",
        background:
          "#f0ebfb",
        border: "#cfc0ee",
      };
    }

    if (
      value.includes(
        "PACIENTE"
      )
    ) {
      return {
        color: "#478155",
        background:
          "#edf5ef",
        border: "#bfd6c5",
      };
    }

    return {
      color: "#6b778c",
      background:
        "#f4f5f7",
      border: "#dfe1e6",
    };
  };

  const renderTipoMovimiento = (
    tipo
  ) => {
    const style =
      getTipoMovimientoStyle(
        tipo
      );

    return (
      <span
        style={{
          display:
            "inline-flex",
          alignItems: "center",
          padding: "4px 7px",
          borderRadius: 5,
          fontSize: 10,
          fontWeight: 600,
          color:
            style.color,
          background:
            style.background,
          border: `1px solid ${style.border}`,
          whiteSpace:
            "normal",
        }}
      >
        {tipo || "—"}
      </span>
    );
  };

  /* =====================================================
     PRECIO
  ===================================================== */

  const formatearPrecio = (
    precio
  ) => {
    if (
      precio === null ||
      precio === undefined ||
      precio === ""
    ) {
      return "";
    }

    const numero =
      Number(precio);

    if (
      Number.isNaN(numero)
    ) {
      return precio;
    }

    return numero.toLocaleString(
      "es-CL"
    );
  };

  /* =====================================================
     EXPORTAR EXCEL
  ===================================================== */

  const ExportarXls = () => {
    if (
      datosFiltrados.length ===
      0
    ) {
      return;
    }

    const dataExcel =
      datosFiltrados.map(
        (documento) => ({
          ...documento,

          fecha:
            formatearFecha(
              documento.fechamod
            ),
        })
      );

    const columnsToShow = [
      "tipo",
      "marca",
      "modelo",
      "status",
      "serie",
      "rut",
      "entidad",
      "fecha",
    ];

    const excelBlob =
      ExportarExcel(
        dataExcel,
        columnsToShow
      );

    const excelURL =
      URL.createObjectURL(
        excelBlob
      );

    const downloadLink =
      document.createElement(
        "a"
      );

    downloadLink.href =
      excelURL;

    downloadLink.download =
      "status.xlsx";

    document.body.appendChild(
      downloadLink
    );

    downloadLink.click();

    document.body.removeChild(
      downloadLink
    );

    URL.revokeObjectURL(
      excelURL
    );
  };

  /* =====================================================
     KPI CARD
  ===================================================== */

  const KpiCard = ({
    titulo,
    valor,
    icono,
    color,
    background,
  }) => (
    <Segment
      style={{
        margin: 0,
        border:
          "1px solid #e5e9ef",
        borderRadius: 8,
        boxShadow:
          "0 1px 3px rgba(9,30,66,0.06)",
        padding: "14px 16px",
        minHeight: 84,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent:
            "space-between",
          gap: 10,
        }}
      >
        <div>
          <div
            style={{
              color: "#8793a5",
              fontSize: 10,
              fontWeight: 700,
              textTransform:
                "uppercase",
              letterSpacing: 0.3,
            }}
          >
            {titulo}
          </div>

          <div
            style={{
              color: "#172b4d",
              fontSize: 23,
              lineHeight: 1.2,
              fontWeight: 700,
              marginTop: 5,
            }}
          >
            {valor}
          </div>
        </div>

        <div
          style={{
            width: 38,
            height: 38,
            minWidth: 38,
            borderRadius: 8,
            background,
            display: "flex",
            alignItems: "center",
            justifyContent:
              "center",
          }}
        >
          <Icon
            name={icono}
            style={{
              margin: 0,
              color,
              fontSize: 17,
            }}
          />
        </div>
      </div>
    </Segment>
  );

  /* =====================================================
     RETURN
  ===================================================== */

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        paddingBottom: 40,
      }}
    >
      <Container
        fluid
        style={{
          maxWidth: 1400,
          margin: "0 auto",
          padding: "20px 16px",
        }}
      >
        {/* =================================================
            CABECERA
        ================================================= */}

        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 14,
            marginBottom: 18,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 13,
              minWidth: 0,
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                minWidth: 48,
                borderRadius: 9,
                background: "#e5f7f7",
                display: "flex",
                alignItems:
                  "center",
                justifyContent:
                  "center",
              }}
            >
              <Icon
                name="tasks"
                style={{
                  margin: 0,
                  color: "#0d9da5",
                  fontSize: 21,
                }}
              />
            </div>

            <div>
              <Header
                as="h2"
                style={{
                  margin: 0,
                  color: "#172b4d",
                  fontSize: 22,
                  fontWeight: 700,
                }}
              >
                Estado de los Equipos
              </Header>

              <div
                style={{
                  marginTop: 3,
                  color: "#8793a5",
                  fontSize: 12,
                }}
              >
                Consulte la ubicación y
                situación actual de los
                equipos en tiempo real.
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            <Label
              basic
              size="small"
              style={{
                margin: 0,
                color: "#478155",
                borderColor:
                  "#bfd6c5",
                background:
                  "#edf5ef",
              }}
            >
              <Icon
                name="circle"
                style={{
                  color: "#21ba45",
                  fontSize: 8,
                }}
              />

              Actualización en línea
            </Label>

            <Button
              color="green"
              icon
              labelPosition="left"
              onClick={
                ExportarXls
              }
              disabled={
                datosFiltrados.length ===
                0
              }
            >
              <Icon name="file excel" />

              Exportar Excel
            </Button>
          </div>
        </div>

        {/* =================================================
            KPIs
        ================================================= */}

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(165px, 1fr))",
            gap: 12,
            marginBottom: 18,
          }}
        >
          <KpiCard
            titulo="Total equipos"
            valor={
              indicadores.total
            }
            icono="archive"
            color="#2185d0"
            background="#eaf4fb"
          />

          <KpiCard
            titulo="En bodega"
            valor={
              indicadores.bodega
            }
            icono="archive"
            color="#2185d0"
            background="#eaf4fb"
          />

          <KpiCard
            titulo="En paciente"
            valor={
              indicadores.paciente
            }
            icono="user"
            color="#478155"
            background="#edf5ef"
          />

          <KpiCard
            titulo="En tránsito"
            valor={
              indicadores.transito
            }
            icono="truck"
            color="#f2711c"
            background="#fff1e8"
          />

          <KpiCard
            titulo="Servicio Técnico"
            valor={
              indicadores.servicioTecnico
            }
            icono="wrench"
            color="#6435c9"
            background="#f0ebfb"
          />
        </div>

        {/* =================================================
            FILTROS
        ================================================= */}

        <Segment
          style={{
            padding: 0,
            borderRadius: 8,
            border:
              "1px solid #e5e9ef",
            boxShadow:
              "0 1px 3px rgba(9,30,66,0.08)",
            overflow: "visible",
            marginBottom: 18,
          }}
        >
          <div
            style={{
              padding:
                "13px 17px",
              borderBottom:
                "1px solid #e5e9ef",
              display: "flex",
              alignItems: "center",
              justifyContent:
                "space-between",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems:
                  "center",
                gap: 8,
                color: "#253858",
                fontWeight: 700,
              }}
            >
              <Icon
                name="filter"
                style={{
                  color: "#0d9da5",
                }}
              />

              Buscar equipos
            </div>

            <Label
              basic
              size="small"
              style={{
                margin: 0,
                color: "#6b778c",
              }}
            >
              Resultados:{" "}
              <strong>
                {
                  datosFiltrados.length
                }
              </strong>
            </Label>
          </div>

          <div
            style={{
              padding: 16,
            }}
          >
            <Grid
              stackable
              verticalAlign="middle"
            >
              <Grid.Row>
                <Grid.Column
                  computer={12}
                  tablet={11}
                  mobile={16}
                >
                  <Input
                    fluid
                    icon="search"
                    iconPosition="left"
                    placeholder="Buscar por serie, equipo, paciente, destino, status, RUT..."
                    value={
                      buscador
                    }
                    onChange={
                      onBuscarCambios
                    }
                    action={
                      buscador
                        ? {
                            icon: "close",
                            basic: true,
                            onClick:
                              limpiarBusqueda,
                          }
                        : undefined
                    }
                  />

                  <div
                    style={{
                      color: "#98a1af",
                      fontSize: 11,
                      marginTop: 6,
                    }}
                  >
                    <Icon name="info circle" />

                    La búsqueda considera
                    todos los campos del
                    registro de status.
                  </div>
                </Grid.Column>

                <Grid.Column
                  computer={4}
                  tablet={5}
                  mobile={16}
                  textAlign="right"
                >
                  <div
                    style={{
                      background:
                        "#f8fafc",
                      border:
                        "1px solid #e5e9ef",
                      borderRadius: 7,
                      padding:
                        "9px 12px",
                      display:
                        "inline-flex",
                      alignItems:
                        "center",
                      gap: 8,
                    }}
                  >
                    <Icon
                      name="list"
                      style={{
                        color:
                          "#2185d0",
                      }}
                    />

                    <span
                      style={{
                        color:
                          "#6b778c",
                        fontSize: 12,
                      }}
                    >
                      Mostrando{" "}
                      <strong
                        style={{
                          color:
                            "#172b4d",
                        }}
                      >
                        {
                          datosFiltrados.length
                        }
                      </strong>{" "}
                      de{" "}
                      <strong
                        style={{
                          color:
                            "#172b4d",
                        }}
                      >
                        {
                          estado.length
                        }
                      </strong>
                    </span>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Segment>

        {/* =================================================
            ERROR
        ================================================= */}

        {errorCarga && (
          <Message
            negative
            icon
            style={{
              marginBottom: 18,
            }}
          >
            <Icon name="warning circle" />

            <Message.Content>
              <Message.Header>
                Error cargando información
              </Message.Header>

              {errorCarga}
            </Message.Content>
          </Message>
        )}

        {/* =================================================
            TABLA
        ================================================= */}

        <Segment
          style={{
            padding: 0,
            borderRadius: 8,
            border:
              "1px solid #e5e9ef",
            boxShadow:
              "0 1px 3px rgba(9,30,66,0.08)",
            overflow: "hidden",
          }}
        >
          {/* HEADER TABLA */}

          <div
            style={{
              padding:
                "13px 17px",
              borderBottom:
                "1px solid #e5e9ef",
              display: "flex",
              alignItems: "center",
              justifyContent:
                "space-between",
              flexWrap: "wrap",
              gap: 10,
              background: "#fff",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems:
                  "center",
                gap: 8,
                color: "#253858",
                fontWeight: 700,
              }}
            >
              <Icon
                name="list alternate outline"
                style={{
                  color:
                    "#2185d0",
                }}
              />

              Status actual
            </div>

            {loading ? (
              <Label
                basic
                size="small"
                style={{
                  margin: 0,
                }}
              >
                <Icon
                  name="spinner"
                  loading
                />

                Cargando...
              </Label>
            ) : (
              <Label
                basic
                size="small"
                style={{
                  margin: 0,
                  color:
                    "#6b778c",
                }}
              >
                {
                  datosFiltrados.length
                }{" "}
                equipo(s)
              </Label>
            )}
          </div>

          {/* TABLA */}

          <div
            style={{
              maxHeight: 610,
              overflow: "auto",
            }}
          >
            <Table
              celled
              compact
              selectable
              unstackable
              style={{
                margin: 0,
                minWidth: 1380,
                border: 0,
                borderRadius: 0,
                fontSize: 12,
              }}
            >
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell
                    style={
                      stickyTh
                    }
                    textAlign="center"
                  >
                    N°
                  </Table.HeaderCell>

                  <Table.HeaderCell
                    style={
                      stickyTh
                    }
                  >
                    Equipamiento
                  </Table.HeaderCell>

                  <Table.HeaderCell
                    style={
                      stickyTh
                    }
                  >
                    Serie
                  </Table.HeaderCell>

                  <Table.HeaderCell
                    style={
                      stickyTh
                    }
                    textAlign="right"
                  >
                    Precio
                  </Table.HeaderCell>

                  <Table.HeaderCell
                    style={
                      stickyTh
                    }
                  >
                    Movimiento
                  </Table.HeaderCell>

                  <Table.HeaderCell
                    style={
                      stickyTh
                    }
                  >
                    Status
                  </Table.HeaderCell>

                  <Table.HeaderCell
                    style={
                      stickyTh
                    }
                  >
                    RUT Origen
                  </Table.HeaderCell>

                  <Table.HeaderCell
                    style={
                      stickyTh
                    }
                  >
                    Nombre Origen
                  </Table.HeaderCell>

                  <Table.HeaderCell
                    style={
                      stickyTh
                    }
                  >
                    RUT Destino
                  </Table.HeaderCell>

                  <Table.HeaderCell
                    style={
                      stickyTh
                    }
                  >
                    Nombre Destino
                  </Table.HeaderCell>

                  <Table.HeaderCell
                    style={
                      stickyTh
                    }
                  >
                    Fecha Status
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {datosFiltrados.map(
                  (
                    item,
                    index
                  ) => (
                    <Table.Row
                      key={
                        item.id ??
                        index
                      }
                    >
                      {/* N */}

                      <Table.Cell
                        textAlign="center"
                        style={{
                          color:
                            "#6b778c",
                        }}
                      >
                        {index + 1}
                      </Table.Cell>

                      {/* EQUIPO */}

                      <Table.Cell
                        style={{
                          whiteSpace:
                            "normal",
                          minWidth:
                            190,
                        }}
                      >
                        <div
                          style={{
                            display:
                              "flex",
                            alignItems:
                              "flex-start",
                            gap: 8,
                          }}
                        >
                          <div
                            style={{
                              width: 29,
                              height: 29,
                              minWidth:
                                29,
                              borderRadius:
                                6,
                              background:
                                "#eaf4fb",
                              display:
                                "flex",
                              alignItems:
                                "center",
                              justifyContent:
                                "center",
                            }}
                          >
                            <Icon
                              name="archive"
                              style={{
                                margin: 0,
                                color:
                                  "#2185d0",
                                fontSize:
                                  12,
                              }}
                            />
                          </div>

                          <div>
                            <div
                              style={{
                                fontWeight:
                                  700,
                                color:
                                  "#172b4d",
                              }}
                            >
                              {item.tipo ||
                                "—"}
                            </div>

                            {(item.marca ||
                              item.modelo) && (
                              <div
                                style={{
                                  marginTop:
                                    2,
                                  fontSize:
                                    11,
                                  color:
                                    "#8793a5",
                                }}
                              >
                                {[
                                  item.marca,
                                  item.modelo,
                                ]
                                  .filter(
                                    Boolean
                                  )
                                  .join(
                                    " "
                                  )}
                              </div>
                            )}
                          </div>
                        </div>
                      </Table.Cell>

                      {/* SERIE */}

                      <Table.Cell>
                        <span
                          style={{
                            fontWeight:
                              600,
                            color:
                              "#42526e",
                            whiteSpace:
                              "nowrap",
                          }}
                        >
                          {item.serie ||
                            "—"}
                        </span>
                      </Table.Cell>

                      {/* PRECIO */}

                      <Table.Cell
                        textAlign="right"
                      >
                        {formatearPrecio(
                          item.price
                        ) || "—"}
                      </Table.Cell>

                      {/* MOVIMIENTO */}

                      <Table.Cell
                        style={{
                          maxWidth:
                            190,
                        }}
                      >
                        {renderTipoMovimiento(
                          item.tipoinout
                        )}
                      </Table.Cell>

                      {/* STATUS */}

                      <Table.Cell>
                        <StatusBadge
                          status={
                            item.status
                          }
                        />
                      </Table.Cell>

                      {/* RUT ORIGEN */}

                      <Table.Cell
                        style={{
                          whiteSpace:
                            "nowrap",
                        }}
                      >
                        {item.r_origen ||
                          "—"}
                      </Table.Cell>

                      {/* ORIGEN */}

                      <Table.Cell
                        style={{
                          whiteSpace:
                            "normal",
                          minWidth:
                            150,
                          color:
                            "#42526e",
                        }}
                      >
                        {item.n_origen ||
                          "—"}
                      </Table.Cell>

                      {/* RUT DESTINO */}

                      <Table.Cell
                        style={{
                          whiteSpace:
                            "nowrap",
                        }}
                      >
                        {item.r_destino ||
                          "—"}
                      </Table.Cell>

                      {/* DESTINO */}

                      <Table.Cell
                        style={{
                          whiteSpace:
                            "normal",
                          minWidth:
                            160,
                          color:
                            "#42526e",
                        }}
                      >
                        {item.n_destino ||
                          "—"}
                      </Table.Cell>

                      {/* FECHA */}

                      <Table.Cell
                        style={{
                          whiteSpace:
                            "nowrap",
                          color:
                            "#6b778c",
                        }}
                      >
                        <Icon
                          name="clock outline"
                          style={{
                            color:
                              "#98a1af",
                          }}
                        />

                        {formatearFecha(
                          item.fechamod
                        ) || "—"}
                      </Table.Cell>
                    </Table.Row>
                  )
                )}

                {/* SIN RESULTADOS */}

                {!loading &&
                  datosFiltrados.length ===
                    0 && (
                    <Table.Row>
                      <Table.Cell
                        colSpan={11}
                        textAlign="center"
                      >
                        <div
                          style={{
                            padding:
                              "38px 15px",
                            color:
                              "#8793a5",
                          }}
                        >
                          <Icon
                            name={
                              buscador
                                ? "search"
                                : "archive"
                            }
                            size="big"
                            style={{
                              color:
                                "#c1c7d0",
                            }}
                          />

                          <div
                            style={{
                              color:
                                "#42526e",
                              fontWeight:
                                600,
                              marginTop:
                                10,
                            }}
                          >
                            {buscador
                              ? "Sin resultados"
                              : "Sin equipos"}
                          </div>

                          <div
                            style={{
                              fontSize:
                                12,
                              marginTop:
                                4,
                            }}
                          >
                            {buscador
                              ? "No hay coincidencias para la búsqueda actual."
                              : "No existen registros de status para mostrar."}
                          </div>
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  )}
              </Table.Body>
            </Table>
          </div>

          {/* FOOTER */}

          <div
            style={{
              padding:
                "10px 16px",
              background:
                "#fbfcfd",
              borderTop:
                "1px solid #e5e9ef",
              display: "flex",
              alignItems: "center",
              justifyContent:
                "space-between",
              gap: 10,
              flexWrap: "wrap",
              color: "#8793a5",
              fontSize: 11,
            }}
          >
            <span>
              <Icon
                name="circle"
                style={{
                  color: "#21ba45",
                  fontSize: 7,
                }}
              />

              Datos sincronizados con
              Firestore
            </span>

            <span>
              Mostrando{" "}
              {
                datosFiltrados.length
              }{" "}
              de {estado.length}
            </span>
          </div>
        </Segment>
      </Container>
    </div>
  );
};

export default Reporte2;